export default "__VITE_ASSET__vwukflpB__"